import { render, staticRenderFns } from "./GroupList.vue?vue&type=template&id=2d967e24&scoped=true"
import script from "./GroupList.vue?vue&type=script&lang=js"
export * from "./GroupList.vue?vue&type=script&lang=js"
import style0 from "./GroupList.vue?vue&type=style&index=0&id=2d967e24&prod&lang=scss&scoped=true"
import style1 from "./GroupList.vue?vue&type=style&index=1&id=2d967e24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d967e24",
  null
  
)

export default component.exports